/// Copyright Chris Doty 2023.  MIT License

import filter from "lodash/filter.js";
import find from "lodash/find.js";
import capitalize from "lodash/capitalize.js";
import throttle from "lodash/throttle.js";
import template from "lodash/template.js";
import merge from "lodash/merge.js";
import templateSettings from "lodash/templateSettings.js";
import debounce from "lodash/debounce.js";
import { formatInTimeZone } from 'date-fns-tz'
import parseISO from 'date-fns/parseISO';

import {inject} from "vue";

let tenUtilOptions = {
};

class tenUtil {
  //setup
  constructor(){
    if(! tenUtil.instance){
      tenUtil.instance = this;

      templateSettings.interpolate=/{([\s\S]+?)}/g;
    }
    return tenUtil.instance;
  }

  // combining arrays and objects
  transform(obj, predicate, remove) {
    return Object.keys(obj).reduce((memo, key) => {
      if(predicate(obj[key], key)) {
        memo[key] = obj[key]
      } else {
        if(remove) {
          console.log("deleting",key);
          delete obj[key];
        }
      }
      return memo
    }, {})
  }
  omit(obj, items) { this.transform(obj, (value, key) => !items.includes(key)) }
  pick(obj, items) { this.transform(obj, (value, key) => items.includes(key)) }
  clean(obj,all) {
    let t=Object.prototype.toString.call( obj );
    if(t==='[object Array]') {
      obj.splice(0, obj.length);
      return obj;
    }
    let excluded=[];
    if(!all) {
      let keys = Object.keys(obj);
      for(let key in keys) {
        if(key.indexOf!==undefined && key.indexOf('_')!==0) continue;
        excluded.push(key);
      }
    }
    this.transform(obj, (value, key) => excluded.includes(key), true);
    return obj;
  }

  cleanExtend(obj) {
    if(obj!==null) {
      if (arguments.length > 1) {
        let t = Object.prototype.toString.call(obj);
        let all = false;
        for (let i = 1; i < arguments.length; i++) {
          let obj2=arguments[i];
          let ta = Object.prototype.toString.call(obj2);
          let isBoolean = (ta === '[object Boolean]');
          if (i === 1) {
            all = isBoolean && arguments[i];
            this.clean(obj, all);
          }
          if (isBoolean) continue; // if second arg is boolean then we ignore it
          if (ta !== t) throw "types must match";

          if (t === '[object Array]') {
            for(let j=0;j<obj2.length;j++) {
              obj.push(obj2[j]); //shallow copy for now
            }
            continue;
          }
          if (t === '[object Object]') {
            let keys = Object.keys(obj2);
            for(let key in keys) {
              let name=keys[key];
              if(name.indexOf!==undefined && name.indexOf('_')===0) continue;
              obj[name]=obj2[name]; //shallow copy for now
            }
          }
        }
      } else {
        this.clean(obj);
      }
    }
    return obj;
  }

  extend(obj) {
    if(obj!==null) {
      if (arguments.length > 1) {
        let t = Object.prototype.toString.call(obj);
        let all = false;
        for (let i = 1; i < arguments.length; i++) {
          let obj2 = arguments[i];
          let ta = Object.prototype.toString.call(obj2);
          let isBoolean = (ta === '[object Boolean]');
          if (i === 1) {
            all = isBoolean && arguments[i];
          }
          if (isBoolean) continue; // if second arg is boolean then we ignore it
          if (ta !== t) throw "types must match";

          if (t === '[object Array]') {
            for (let j = 0; j < obj2.length; j++) {
              obj.push(obj2[j]); //shallow copy for now
            }
            continue;
          }
          if (t === '[object Object]') {
            let keys = Object.keys(obj2);
            for (let key in keys) {
              let name = keys[key];
              if (name.indexOf !== undefined && name.indexOf('_') === 0) continue;
              obj[name] = obj2[name]; //shallow copy for now
            }
          }
        }
      }
    }
    return obj;
  }

  //debounce
  //debounce( func, wait, options )
  debounce = debounce

  //throttle
  //throttle(func, [wait=0], [options={}])
  throttle = throttle

  // filter
  //filter(collection, [predicate=_.identity])
  filter = filter

  // find
  ///find(collection, [predicate=_.identity], [fromIndex=0])
  find = find

  // merge
  ///merge( object, sources )
  merge = merge

  // fields
  ///properCase([string=''])
  properCase=capitalize

  focusByID(id) {
    setTimeout(()=>{document.getElementById(id).focus();},200);
  }

  ////////////////////////////
  // clipboard
  /// https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
  fallbackCopyTextToClipboard(text) {
    let textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      let successful = document.execCommand('copy');
      let msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  }
  copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      this.fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  }
  ////////////////////////////

  cyrb53(str, seed = 0) {
    let h1 = 0xdeadbeef ^ seed, h2 = 0x41c6ce57 ^ seed;
    for(let i = 0, ch; i < str.length; i++) {
      ch = str.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1  = Math.imul(h1 ^ (h1 >>> 16), 2246822507);
    h1 ^= Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2  = Math.imul(h2 ^ (h2 >>> 16), 2246822507);
    h2 ^= Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
  };

  // macros
  macroCache={}
  macroReplace(str, values){
    let hc=this.cyrb53(str);
    console.log(hc);
    if(this.macroCache[hc]) return this.macroCache[hc](values);
    let compiled = template(str);
    this.macroCache[hc]=compiled;
    return compiled(values);
  }

  //lists
  sortList(sortedList,sortBy){
    let list = this.cleanExtend([],sortedList);
    list.sort((p1,p2) => {
      let modifier = 1;
      let fc=sortBy.substring(0,1);
      if(fc==="-" || fc==="+") {
        modifier=(fc==="-"? -1 : 1);
        sortBy=sortBy.substring(1);
      }
      sortBy = sortBy || "name";
      if(p1[sortBy] < p2[sortBy]) return -1 * modifier; if(p1[sortBy] > p2[sortBy]) return 1 * modifier;
      return 0;
    });
    this.cleanExtend(sortedList,list);
  }

  formatDate(dte) {
    if(!dte) return '';
    if(typeof(dte)==="string") dte=parseISO(dte);
    const settings = inject('settings');
    return formatInTimeZone(dte, settings.timeZone, settings.dateFormat||'yyyy-MM-dd');
  }

  formatDateTime(dte) {
    if(!dte) return '';
    if(typeof(dte)==="string") dte=parseISO(dte);
    const settings = inject('settings');
    return formatInTimeZone(dte, 'America/New_York', settings.dateTimeFormat||'yyyy-MM-dd HH:mm');
  }

  formatDateTimeLong(dte) {
    if(!dte) return '';
    if(typeof(dte)==="string") dte=parseISO(dte);
    const settings = inject('settings');
    return formatInTimeZone(dte, 'America/New_York', settings.dateTimeFormat||'yyyy-MM-dd HH:mm:ss');
  }

  formatCurrency(num) {
    if(num===undefined) return '';
    num=parseFloat(''+num)
    const settings = inject('settings');
    return new Intl.NumberFormat(settings.languageCode||'USD', { style: 'currency', currency: settings.currencyCode||'USD' }).format(num);
  }
}

const instance = new tenUtil();

export default instance;
